import { Injectable } from '@angular/core';

/**
 * Is an internal editing screen on the page right now - the /nihul area, or the edit overlay
 * on a public content page?
 *
 * The nihul reads the SAME public apis the site does (deliberately: they are the fast, cached
 * ones), which means an editor who just saved can be answered from a cache that predates their
 * own change. Everything the save CAN purge is purged - the server caches, varnish and the cdn -
 * but nothing can reach into the editor's browser cache, and those api answers carry
 * `max-age=120`. So while a nihul screen is up, RequestInterceptor marks the public-api reads
 * with `nihul=1`: a different url (so the browser's stored copy is not a match) which varnish
 * answers with `no-store` and strips before hashing, so the nihul keeps sharing the one public
 * cache object. See AGENTS.md / docs/agents/cache-flow.md.
 *
 * A plain counter, not a signal: it is read from an http interceptor, which must not become a
 * reactive dependency of whatever happens to be rendering. Nested (shell + overlay) never
 * happens today, but counting keeps the two callers from clobbering each other.
 */
@Injectable({ providedIn: 'root' })
export class NihulModeService {
    private _depth = 0;

    /** true while any nihul screen is on the page */
    public active(): boolean {
        return this._depth > 0;
    }

    public enter(): void {
        this._depth++;
    }

    public leave(): void {
        this._depth = this._depth > 0 ? this._depth - 1 : 0;
    }
}
